import React from 'react';
import { GlobalStyles } from '../../styles/styledComponents/globalStyles';
import ParticlesContainer from '../Particles/ParticlesContainer';
import {
    PageBackground,
    PageBackgroundContainer
} from './PageContainerStyle';
import PageInformationContainer from '../PageInformation/PageInformationContainer';
import CONFIG from '../../config';
import UbisoftPlusNavigation from '../UbisoftPlusNavigation/UbisoftPlusNavigation';

const PageContainer = () => {
    return (
        <>
            {/*Global styles defenition*/}
            <GlobalStyles />

            {!CONFIG.isUPC && <UbisoftPlusNavigation />}
            {/*Animated background*/}
            <PageBackgroundContainer>
                <PageBackground>
                    <ParticlesContainer />
                </PageBackground>
            </PageBackgroundContainer>
            <PageInformationContainer/>
        </>
    );
};

export default PageContainer;
